import {
	IRPCResponse,
	IRPCPublishment,
	RPCID,
	ISerializedError,
	errorTypes
} from '@staffbar/types'

export class RPCResponse implements IRPCResponse {
  constructor(response: IRPCResponse) {
    this.id = response.id
    this.result = response.result
    this.error = response.error
  }

  id: RPCID
  result?: any
  error?: ISerializedError 

  public success(): boolean {
    return this.error === undefined
  }

  public toSuccess(): any {
    return this.result!
  }

  public toError(): Error {
    let errorString = this.error?.message || 'Unknown error occurred'
    var errorType: any = Error;
    if (Object.keys(errorTypes).includes(this.error?.errorType!)) {
      errorType = errorTypes[this.error?.errorType!];
    }
    return new errorType(errorString)
  }
}

export class RPCPublishment implements IRPCPublishment {
	
  constructor({ publishmentName, message }: { publishmentName: string, message: string }) {
    this.publishmentName = publishmentName;
    this.message = message;
  }

  public publishmentName: string;
  public message: any;
}
